export const CONSTANTS = {
  DEFAULT_AKTIENGEWICHTUNG_ETF_PORTFOLIO_PLUS_NAME: 'ETF-Portfolio Plus 90'
};
